import React from 'react';
import logo from '../../assets/icons/footerLogo.png';
import { Link } from 'react-router-dom';

const Footer = () => {
	return (
		<footer className='px-8 text-lg dark:bg-lawBlack dark:text-white'>
			<div className='container flex flex-col justify-between py-10 mx-auto space-y-8 lg:flex-row lg:space-y-0'>
				<div className='lg:ml-12 xl:w-2/5'>
					<Link
						rel='noopener noreferrer'
						to='/'
						className='flex items-center space-x-1 lg:justify-start pb-3'
					>
						<img
							className='self-center md:size-20 shrink-0 -ml-2'
							src={logo}
							alt='UILSS'
							loading='lazy'
						/>
						<span className='font-medium text-md sm:text-3xl text-yellow'>
							LawStudentsSociety
						</span>
					</Link>
					<p className='mb-2 text-white text-left font-light text-base'>
						<span className='flex flex-row items-center'>
							<svg
								className='mr-2 size-6 md:size-8 shrink-0'
								width='32'
								height='32'
								viewBox='0 0 32 32'
								fill='none'
								xmlns='http://www.w3.org/2000/svg'
							>
								<path
									d='M16 18C15.0111 18 14.0444 17.7068 13.2222 17.1574C12.3999 16.6079 11.759 15.8271 11.3806 14.9134C11.0022 13.9998 10.9031 12.9945 11.0961 12.0246C11.289 11.0546 11.7652 10.1637 12.4645 9.46447C13.1637 8.76521 14.0546 8.289 15.0246 8.09608C15.9945 7.90315 16.9998 8.00217 17.9134 8.3806C18.8271 8.75904 19.6079 9.39991 20.1574 10.2222C20.7068 11.0444 21 12.0111 21 13C20.9984 14.3256 20.4711 15.5964 19.5338 16.5338C18.5964 17.4711 17.3256 17.9984 16 18ZM16 10C15.4067 10 14.8266 10.1759 14.3333 10.5056C13.8399 10.8352 13.4554 11.3038 13.2284 11.852C13.0013 12.4001 12.9419 13.0033 13.0576 13.5853C13.1734 14.1672 13.4591 14.7018 13.8787 15.1213C14.2982 15.5409 14.8328 15.8266 15.4147 15.9424C15.9967 16.0581 16.5999 15.9987 17.1481 15.7716C17.6962 15.5446 18.1648 15.1601 18.4944 14.6667C18.8241 14.1734 19 13.5933 19 13C18.9992 12.2046 18.6829 11.442 18.1204 10.8796C17.558 10.3171 16.7954 10.0008 16 10Z'
									fill='white'
								/>
								<path
									d='M16 30L7.56401 20.051C7.44679 19.9016 7.33079 19.7513 7.21601 19.6C5.77499 17.7018 4.99652 15.3832 5.00001 13C5.00001 10.0826 6.15894 7.28473 8.22184 5.22183C10.2847 3.15893 13.0826 2 16 2C18.9174 2 21.7153 3.15893 23.7782 5.22183C25.8411 7.28473 27 10.0826 27 13C27.0035 15.3821 26.2254 17.6996 24.785 19.597L24.784 19.6C24.784 19.6 24.484 19.994 24.439 20.047L16 30ZM8.81301 18.395C8.81301 18.395 9.04601 18.703 9.09901 18.769L16 26.908L22.91 18.758C22.954 18.703 23.188 18.393 23.189 18.392C24.3662 16.8411 25.0023 14.947 25 13C25 10.6131 24.0518 8.32387 22.364 6.63604C20.6761 4.94821 18.387 4 16 4C13.6131 4 11.3239 4.94821 9.63605 6.63604C7.94822 8.32387 7.00001 10.6131 7.00001 13C6.99791 14.9482 7.63479 16.8434 8.81301 18.395Z'
									fill='white'
								/>
							</svg>
							Faculty of Law Unilorin, Ilorin
						</span>
					</p>
					<p className='flex flex-row items-center mb-2 text-white text-left font-light text-base break-all'>
						<svg
							className='mr-3 size-6 shrink-0'
							width='23'
							height='20'
							viewBox='0 0 23 20'
							fill='none'
							xmlns='http://www.w3.org/2000/svg'
						>
							<g clipPath='url(#clip0_223_218)'>
								<path
									d='M20.7143 18.5713H2.14286C0.957143 18.5713 0 17.6142 0 16.4285V3.57132C0 2.38561 0.957143 1.42847 2.14286 1.42847H20.7143C21.9 1.42847 22.8571 2.38561 22.8571 3.57132V16.4285C22.8571 17.6142 21.9 18.5713 20.7143 18.5713ZM2.14286 2.85704C1.74286 2.85704 1.42857 3.17132 1.42857 3.57132V16.4285C1.42857 16.8285 1.74286 17.1428 2.14286 17.1428H20.7143C21.1143 17.1428 21.4286 16.8285 21.4286 16.4285V3.57132C21.4286 3.17132 21.1143 2.85704 20.7143 2.85704H2.14286Z'
									fill='white'
								/>
								<path
									d='M11.4287 12.8C10.4287 12.8 9.51446 12.4 8.82874 11.6714L1.32874 3.69996C1.05731 3.41425 1.0716 2.9571 1.35731 2.68567C1.64303 2.41425 2.10017 2.42853 2.3716 2.71425L9.8716 10.6857C10.6859 11.5571 12.1716 11.5571 12.9859 10.6857L20.4859 2.72853C20.7573 2.44282 21.2145 2.42853 21.5002 2.69996C21.7859 2.97139 21.8002 3.42853 21.5287 3.71425L14.0287 11.6857C13.343 12.4142 12.4287 12.8142 11.4287 12.8142V12.8Z'
									fill='white'
								/>
							</g>
							<defs>
								<clipPath id='clip0_223_218'>
									<rect width='22.8571' height='20' fill='white' />
								</clipPath>
							</defs>
						</svg>
						lawstudentsocietyunilorin@gmail.com
					</p>
					<p className='flex flex-row items-center mb-2 text-white text-left font-light text-base'>
						<svg
							className='mr-2 size-6 md:size-8 shrink-0'
							width='24'
							height='24'
							viewBox='0 0 24 24'
							fill='none'
							xmlns='http://www.w3.org/2000/svg'
						>
							<path
								d='M6.78839 2.26703L8.21125 1.83846C8.85895 1.64305 9.55564 1.69003 10.1712 1.97062C10.7868 2.25122 11.2793 2.74625 11.5567 3.36332L12.4421 5.33303C12.6807 5.86365 12.7472 6.45566 12.6322 7.02598C12.5172 7.5963 12.2265 8.11631 11.801 8.51303L10.2538 9.9556C10.2347 9.97346 10.219 9.99467 10.2075 10.0182C10.0455 10.349 10.2915 11.2327 11.0621 12.5682C11.9313 14.0733 12.6024 14.6682 12.9135 14.5765L14.9441 13.955C15.5002 13.7852 16.0955 13.7937 16.6466 13.9792C17.1976 14.1647 17.6768 14.518 18.017 14.9896L19.2753 16.7322C19.6703 17.2793 19.8533 17.9513 19.7902 18.6232C19.7272 19.2951 19.4223 19.9212 18.9324 20.3853L17.8498 21.4096C17.4734 21.7662 17.0162 22.0264 16.5174 22.1681C16.0186 22.3097 15.4929 22.3286 14.9853 22.223C11.9707 21.5956 9.26982 19.1682 6.85954 14.9939C4.44839 10.817 3.69668 7.25989 4.66525 4.33446C4.82739 3.84469 5.10503 3.40115 5.47472 3.0413C5.84441 2.68146 6.29443 2.41589 6.78839 2.26703ZM7.16125 3.49789C6.86486 3.58716 6.59431 3.74647 6.37247 3.96234C6.15062 4.17822 5.984 4.44432 5.88668 4.73817C5.05182 7.25903 5.72811 10.4613 7.97382 14.351C10.2178 18.2382 12.6504 20.4239 15.2484 20.9639C15.553 21.0271 15.8684 21.0157 16.1677 20.9306C16.4669 20.8455 16.7412 20.6893 16.967 20.4753L18.0487 19.4519C18.3126 19.2021 18.4768 18.8649 18.5109 18.5031C18.5449 18.1413 18.4465 17.7794 18.2338 17.4847L16.9755 15.7413C16.7924 15.4874 16.5344 15.2972 16.2378 15.1973C15.9411 15.0974 15.6207 15.0928 15.3213 15.1842L13.2855 15.8073C12.1593 16.1425 11.0998 15.2039 9.94954 13.2102C8.97497 11.5233 8.63725 10.3045 9.05382 9.45332C9.13439 9.28874 9.24411 9.14046 9.37782 9.01532L10.925 7.57274C11.1542 7.35913 11.3108 7.07909 11.3727 6.77194C11.4347 6.46479 11.3989 6.14595 11.2704 5.86017L10.3841 3.89132C10.2348 3.55897 9.96954 3.29234 9.63798 3.14123C9.30643 2.99013 8.93121 2.96487 8.58239 3.07017L7.16125 3.49789Z'
								fill='white'
							/>
						</svg>
						+2349093862098
					</p>
				</div>
				<div className='grid grid-cols gap-x-3 gap-y-8 xl:w-3/5 sm:grid-cols-3'>
					<div className='space-y-3 lg:pt-6'>
						<h1 className='font-medium text-2xl'>Contact</h1>
						<ul className='space-y-1'>
							<li>
								<Link
									rel='noopener noreferrer'
									target='_blank'
									to='https://www.instagram.com/'
									title='Instagram'
									className='flex flex-row items-center'
								>
									<svg
										xmlns='http://www.w3.org/2000/svg'
										viewBox='0 0 32 32'
										fill='currentColor'
										className='size-6 fill-current mr-2'
									>
										<path d='M16 0c-4.349 0-4.891 0.021-6.593 0.093-1.709 0.084-2.865 0.349-3.885 0.745-1.052 0.412-1.948 0.959-2.833 1.849-0.891 0.885-1.443 1.781-1.849 2.833-0.396 1.020-0.661 2.176-0.745 3.885-0.077 1.703-0.093 2.244-0.093 6.593s0.021 4.891 0.093 6.593c0.084 1.704 0.349 2.865 0.745 3.885 0.412 1.052 0.959 1.948 1.849 2.833 0.885 0.891 1.781 1.443 2.833 1.849 1.020 0.391 2.181 0.661 3.885 0.745 1.703 0.077 2.244 0.093 6.593 0.093s4.891-0.021 6.593-0.093c1.704-0.084 2.865-0.355 3.885-0.745 1.052-0.412 1.948-0.959 2.833-1.849 0.891-0.885 1.443-1.776 1.849-2.833 0.391-1.020 0.661-2.181 0.745-3.885 0.077-1.703 0.093-2.244 0.093-6.593s-0.021-4.891-0.093-6.593c-0.084-1.704-0.355-2.871-0.745-3.885-0.412-1.052-0.959-1.948-1.849-2.833-0.885-0.891-1.776-1.443-2.833-1.849-1.020-0.396-2.181-0.661-3.885-0.745-1.703-0.077-2.244-0.093-6.593-0.093zM16 2.88c4.271 0 4.781 0.021 6.469 0.093 1.557 0.073 2.405 0.333 2.968 0.553 0.751 0.291 1.276 0.635 1.844 1.197 0.557 0.557 0.901 1.088 1.192 1.839 0.22 0.563 0.48 1.411 0.553 2.968 0.072 1.688 0.093 2.199 0.093 6.469s-0.021 4.781-0.099 6.469c-0.084 1.557-0.344 2.405-0.563 2.968-0.303 0.751-0.641 1.276-1.199 1.844-0.563 0.557-1.099 0.901-1.844 1.192-0.556 0.22-1.416 0.48-2.979 0.553-1.697 0.072-2.197 0.093-6.479 0.093s-4.781-0.021-6.48-0.099c-1.557-0.084-2.416-0.344-2.979-0.563-0.76-0.303-1.281-0.641-1.839-1.199-0.563-0.563-0.921-1.099-1.197-1.844-0.224-0.556-0.48-1.416-0.563-2.979-0.057-1.677-0.084-2.197-0.084-6.459 0-4.26 0.027-4.781 0.084-6.479 0.083-1.563 0.339-2.421 0.563-2.979 0.276-0.761 0.635-1.281 1.197-1.844 0.557-0.557 1.079-0.917 1.839-1.199 0.563-0.219 1.401-0.479 2.964-0.557 1.697-0.061 2.197-0.083 6.473-0.083zM16 7.787c-4.541 0-8.213 3.677-8.213 8.213 0 4.541 3.677 8.213 8.213 8.213 4.541 0 8.213-3.677 8.213-8.213 0-4.541-3.677-8.213-8.213-8.213zM16 21.333c-2.948 0-5.333-2.385-5.333-5.333s2.385-5.333 5.333-5.333c2.948 0 5.333 2.385 5.333 5.333s-2.385 5.333-5.333 5.333zM26.464 7.459c0 1.063-0.865 1.921-1.923 1.921-1.063 0-1.921-0.859-1.921-1.921 0-1.057 0.864-1.917 1.921-1.917s1.923 0.86 1.923 1.917z'></path>
									</svg>
									Instagram
								</Link>
							</li>
							<li>
								<Link
									rel='noopener noreferrer'
									to='https://wwww.x.com'
									className='flex flex-row items-center'
								>
									<svg
										className='size-6 mr-2'
										width='24'
										height='24'
										viewBox='0 0 24 24'
										fill='none'
										xmlns='http://www.w3.org/2000/svg'
									>
										<g clipPath='url(#clip0_223_237)'>
											<path
												d='M14.2341 10.1625L22.9764 0H20.9046L13.3138 8.82375L7.25081 0H0.257812L9.42619 13.3433L0.257812 24H2.32969L10.3461 14.6818L16.7488 24H23.7418L14.2335 10.1625H14.2341ZM11.3964 13.4606L10.4674 12.132L3.07613 1.55962H6.25838L12.2229 10.092L13.1518 11.4206L20.9055 22.5112H17.7236L11.3964 13.4612V13.4606Z'
												fill='white'
											/>
										</g>
										<defs>
											<clipPath id='clip0_223_237'>
												<rect width='24' height='24' fill='white' />
											</clipPath>
										</defs>
									</svg>
									Twitter
								</Link>
							</li>
							<li>
								<Link
									rel='noopener noreferrer'
									to='https://www.linkedin.com'
									className='flex flex-row items-center'
								>
									<svg
										className='size-6 mr-2'
										width='18'
										height='18'
										viewBox='0 0 18 18'
										fill='none'
										xmlns='http://www.w3.org/2000/svg'
									>
										<path
											d='M16 0C16.5304 0 17.0391 0.210714 17.4142 0.585786C17.7893 0.960859 18 1.46957 18 2V16C18 16.5304 17.7893 17.0391 17.4142 17.4142C17.0391 17.7893 16.5304 18 16 18H2C1.46957 18 0.960859 17.7893 0.585786 17.4142C0.210714 17.0391 0 16.5304 0 16V2C0 1.46957 0.210714 0.960859 0.585786 0.585786C0.960859 0.210714 1.46957 0 2 0H16ZM15.5 15.5V10.2C15.5 9.33539 15.1565 8.5062 14.5452 7.89483C13.9338 7.28346 13.1046 6.94 12.24 6.94C11.39 6.94 10.4 7.46 9.92 8.24V7.13H7.13V15.5H9.92V10.57C9.92 9.8 10.54 9.17 11.31 9.17C11.6813 9.17 12.0374 9.3175 12.2999 9.58005C12.5625 9.8426 12.71 10.1987 12.71 10.57V15.5H15.5ZM3.88 5.56C4.32556 5.56 4.75288 5.383 5.06794 5.06794C5.383 4.75288 5.56 4.32556 5.56 3.88C5.56 2.95 4.81 2.19 3.88 2.19C3.43178 2.19 3.00193 2.36805 2.68499 2.68499C2.36805 3.00193 2.19 3.43178 2.19 3.88C2.19 4.81 2.95 5.56 3.88 5.56ZM5.27 15.5V7.13H2.5V15.5H5.27Z'
											fill='white'
										/>
									</svg>
									LinkedIn
								</Link>
							</li>
						</ul>
					</div>
					<div className='space-y-3 lg:pt-6'>
						<h1 className='font-medium text-2xl'>Engage</h1>
						<ul className='space-y-1 text-left'>
							<li>
								<Link rel='noopener noreferrer' to='engage/2'>
									Mentorship
								</Link>
							</li>
							<li>
								<Link rel='noopener noreferrer' to='engage/3'>
									Volunteering
								</Link>
							</li>
							<li>
								<Link rel='noopener noreferrer' to='/network'>
									Networking
								</Link>
							</li>
							<li>
								<Link rel='noopener noreferrer' to='engage/4'>
									Donation
								</Link>
							</li>
						</ul>
					</div>
					<div className='space-y-3 lg:pt-6'>
						<h1 className='font-medium text-2xl'>Resources</h1>
						<ul className='space-y-1 text-left'>
							<li>
								<Link rel='noopener noreferrer' to='/about'>
									Terms of Service
								</Link>
							</li>
							<li>
								<Link rel='noopener noreferrer' to='/about'>
									About
								</Link>
							</li>
							<li>
								<Link rel='noopener noreferrer' to='/about'>
									FAQs
								</Link>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div className='mt-[9.1875rem] py-6 text-sm text-right dark:text-gray-400'>
				© 2023 LawStudentSociety , All rights reserved
			</div>
		</footer>
	);
};

export default Footer;
